module.exports = "<app-layout>\n</app-layout>"